import Razor from "../../Razorpay/Razor";
import { useEffect, useState } from "react";
import { getData, postData, putData } from "../../global/Globalapi";
import { toast } from "react-toastify";
import { useNavigate} from 'react-router-dom';
import CartSuccessPopup from "../../Cart/CartSuccessPopup";
import { IoArrowBackOutline, IoHandRightOutline } from "react-icons/io5";
import SignupModal from "../Account/SignupModal";
import LoginModal from "../Account/LoginModal";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import Reviews from "../Reviews";
import ShowReviews from "../ShowReviews";
import Modal from "./modal";
import { fetchCartItems, handleDecrease, handleIncrease, handleRemove } from "../../Cart/CartFunctions";
const ProductView = ({
  product,
  type,
  mainImage,
  thumbnails,
  setMainImage,
  variantAttributes,
  commonAttributes,
  selectedVariants,
  handleVariantSelect,
  childProduct,
  childOptions,
  childid,
  selectedChildOptions,
  setSelectedChildOptions,
  setSelectedVariants,
  id,
  handleCancelAdd,
  stockStatus,
  totalStock
}) => { 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [existingQuantity, setExistingQuantity] = useState(0);
  const [isSignUp, setSignUp] = useState(false);
  const [user, setUser] = useState(null);
  const [pendingAddToCart, setPendingAddToCart] = useState(false);
  const navigate = useNavigate();
  const price = childProduct ? childProduct.unit_selling_price : product.net_price_rtl;
  const [like, setLike] = useState(false);
  const [carrtpopup,setcartpopup] =  useState(false);
  const usertypeid = localStorage.getItem('usertypeid');
  const [rating,setRating] = useState(0);
  const [pendingAddToWishlist, setPendingAddToWishlist] = useState(false); 
  const [isReviewsModalOpen, setIsReviewsModalOpen] = useState(false);
  const handleOpenReviewsModal = () => setIsReviewsModalOpen(true);
  const handleCloseReviewsModal = () => setIsReviewsModalOpen(false);
  const [cartItemId, setCartItemId] = useState(null);
const [quantity, setQuantity] = useState(1);
const increaseQty = () => {
  setQuantity(prev => prev + 1);
};

const decreaseQty = () => {
  if (quantity > 1) {
    setQuantity(prev => prev - 1);
  } else {
    toast.warn("Quantity cannot go below 1");
  }
};

  const HandleLike=()=>{
    setLike(!like )
  }
  const handlesubmit=async()=>{
    try {
      const res=await putData(`/manageproduct/${id}/${usertypeid}`)
      handleCancelAdd();
    } catch (error) {
      
    }
  }
const finalDescription =
  product.images?.[0]?.description?.trim()
    ? product.images[0].description
    : product.description;
  const [prod,setprod]=useState({});
  console.log("has variant ",product.has_variant)
  const isOutOfStock = stockStatus === 'OUT_OF_STOCK' || totalStock === 0;
  console.log("childProduct:", childProduct);
  console.log("childid:", childid);
  console.log("isOutOfStock:", isOutOfStock);
  let isPurchasable = false;
  let purchaseBlockReason = '';
if (product?.has_variant === 0) {
  // Product WITHOUT variants
  if (isOutOfStock || totalStock === 0) {
    isPurchasable = false;
    purchaseBlockReason = 'out_of_stock';
  } else {
    isPurchasable = true;
  }
} else if (product?.has_variant === 1) {
  // Product WITH variants
  if (!childProduct || !childProduct.unit_selling_price) {
    // No variant selected yet
    isPurchasable = false;
    purchaseBlockReason = 'select_variant';
  } else {
    // Variant is selected - check stock
    const childStock = childProduct.total_stock || childProduct.initial_stock || 0;
    const childStockStatus = childProduct.stock_status;
    
    console.log('Child Product Stock Check:', {
      childStock: childStock,
      childStockStatus: childStockStatus,
      total_stock: childProduct.total_stock,
      initial_stock: childProduct.initial_stock
    });
    
    if (childStockStatus === 'OUT_OF_STOCK' || childStock === 0) {
      isPurchasable = false;
      purchaseBlockReason = 'out_of_stock';
    } else {
      isPurchasable = true;
    }
  }
}

console.log('Purchase Decision:', {
  has_variant: product?.has_variant,
  isPurchasable: isPurchasable,
  purchaseBlockReason: purchaseBlockReason,
  childProduct: childProduct ? 'exists' : 'null'
});
  useEffect(()=>{
    console.log("Selected Child Options:", selectedChildOptions);
  },[selectedChildOptions])
  useEffect(()=>{
  },[product])

  useEffect(()=>{
    console.log(type);
  },[])
  useEffect(() => {
   if (user && pendingAddToCart) {
    handleaddtocart(); 
     setPendingAddToCart(false); 
   }
}, [user]);
// useEffect(() => {
//   const guestuserid=user
//   const userString = localStorage.getItem("user");
//   const users = userString ? JSON.parse(userString) : null;
//   const userId = users?.user_id || null;
//   console.log("User ID in cart count:", userId);

//   const fetchExistingCartItem = async () => {
//     if (!userId) return;

//     try {
//       console.log("check id",id);
//       const res = await getData(`/cart/${userId}`);
//       if (Array.isArray(res.data)) {
//         let matchedItem;

//         if (childid) {
//           matchedItem = res.data.find(item => item.child_id === childid);
//         } else {
          
//           // matchedItem = res.data.find(item=> item.product_id === id);
//               matchedItem = res.data.find(item => {
//                console.log("Product match check:", item.product_id, "===", id);
//                return item.product_id === Number(id);
//               });

//         }
//         console.log("matchedItem",matchedItem);
//         // if (matchedItem) {
//         //   setExistingQuantity(matchedItem.quantity);
//         // } else {
//         //   setExistingQuantity(0);
//         // }
//         if (matchedItem) {
//   setExistingQuantity(matchedItem.quantity);
//   setCartItemId(matchedItem.id); // ✅ ADD THIS
// } else {
//   setExistingQuantity(0);
//   setCartItemId(null); // ✅ ADD THIS
// }

//       }
//     } catch (error) {
//       console.error("Error checking existing cart item:", error);
//     }
//   };

//   fetchExistingCartItem();
// }, [childid, id, selectedVariants, selectedChildOptions,carrtpopup,]);


  
    //   const fetchCartItems = async () => {
    //   try {
    //     console.log(userId)
    //     const res = await getData(`/cart/${userId}`);
    //     return res.data
    //   } catch (err) {
    //     console.error("Error fetching cart:", err);
    //   }
    // };
    // const handlePayment = async (amount) => {

    //     const isScriptLoaded = await Razor();
    //     if (!isScriptLoaded) {
    //       alert("Razorpay SDK failed to load. Are you online?");
    //       return;
    //     }
    
    //     // Create order on server
    //     const orderRes = await postData("/create-order", { amount });
    //     console.log("function", amount);
    //     console.log('razorpay response',orderRes);
    //     const options = {
    //       key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Must be set in .env
    //       amount: amount, // in paise
    //       currency: "INR",
    //       name: "Bolt And Brook",
    //       description: "Product Purchase",
    //       order_id: orderRes.id,
    //       notes: {
    //          user_id: userId,
    //          name: userdetails?.name,
    //          email: userdetails?.email,
    //          phone: userdetails?.phone,
    //          cart_summary: "Optional: Add cart items here",
    //         },
    //       handler: function (response) {
    //         toast.success("Payment successful!",);
    //         console.log("Payment Details:", response);
    //         console.log('orderdetails',orderRes)
    //         // Optional: Send to backend for verification
    //       },
    //       prefill: {
    //         name: userdetails?.name ,
    //         email: userdetails?.email ,
    //         contact: userdetails?.phone ,
    //       },

    //       theme: {
    //         color: "#ff0000",
    //       },
    //     };
    
    //     const rzp = new window.Razorpay(options);
    //     rzp.open();
    //   };
 
 useEffect(() => {
  const userString = localStorage.getItem("user");
  const users = userString ? JSON.parse(userString) : null;
  const userId = users?.user_id || null;

  if (!userId) return;

  const fetchExistingCartItem = async () => {
    try {
      const res = await getData(`/cart/${userId}`);

      if (!Array.isArray(res.data)) return;

      let matchedItems = [];

      if (childid) {
        matchedItems = res.data.filter(
          item => item.child_id === childid
        );
      } else {
        matchedItems = res.data.filter(
          item => item.product_id === Number(id)
        );
      }

      console.log("Matched cart rows:", matchedItems);

      const totalQty = matchedItems.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      );

      console.log("Total Existing Quantity:", totalQty);

      setExistingQuantity(totalQty);
      setCartItemId(matchedItems.length ? matchedItems[0].id : null);

    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  };

  fetchExistingCartItem();
}, [childid, id, carrtpopup]);

    const onContinueShopping=()=>{
  setcartpopup(false);
 }
 const onGoToCart=()=>{
  navigate('/cart');
  setcartpopup(false);
 }
 const onBuyNow=async()=>{
  navigate("/checkout");
 }
 const handleaddtocart=async()=>{
   const userstring= localStorage.getItem("user");
   const users=userstring? JSON.parse(userstring) : null;
   const userId = users?.user_id || null;
   console.log("user",users);
   console.log("userId",userId);
     if (!userId) {
     setIsModalOpen(true);
     setPendingAddToCart(true); 
    return;
    }
    setPendingAddToCart(false)
   const cartItemOptions = {};
  for (const label in selectedVariants) {
    if (selectedVariants[label]?.value) {
      cartItemOptions[label] = selectedVariants[label].value;
    }
  }

  for (const label in selectedChildOptions) {
    if (selectedChildOptions[label]?.value) {
      cartItemOptions[label] = selectedChildOptions[label].value;
    }
  }
  const updatedoptions=Object.keys(cartItemOptions).sort().reduce((acc, key) => {
  acc[key.toLowerCase()] = cartItemOptions[key];
  return acc;
}, {})
  console.log("frontend options",updatedoptions);
//   const newcartitem={
//    user_id:userId,
//    childid:childid?childid:null,
//    parentid:Number(id),
//    image_url:mainImage,
//    product_name:product.product_name,
//    amount:childProduct?childProduct.unit_selling_price:product.net_price_rtl,
//    options:updatedoptions
// }
const newcartitem = {
  user_id: userId,
  childid: childid ? childid : null,
  parentid: Number(id),
  image_url: mainImage,
  product_name: product.product_name,
  unit_selling_price: product.unit_selling_price,
  amount: childProduct?childProduct.unit_selling_price:product.net_price_rtl,
  quantity: quantity, // ✅ ADD THIS
  options: updatedoptions
};

console.log("newcartitem",newcartitem);

   try {
    console.log("newcartitem",newcartitem);
    const res = await postData("/cart", newcartitem);
    if(res.status==200){
      setprod(newcartitem);
      setcartpopup(true);
    }
    // toast.success(`${product.product_name} added to cart!`, {
    //   position: "top-center",
    //   autoClose: 2000,
    //   hideProgressBar: true,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: true,
    //   theme: "light",
    // });
  } catch (error) {
    toast.error("Failed to add to cart");
    console.error("Cart API error:", error);
  }
  }
const handlewish = async () => {
    // 1. Get the JSON string from localStorage.
    const userstring = localStorage.getItem("user");
    // 2. Parse the JSON string back into a JavaScript object.
    // Use the component's 'user' state as a fallback if you're using context/external state
    const users = userstring ? JSON.parse(userstring) : null;
    
    // 3. Get the user's ID from the object.
    // Assuming a regular logged-in user has an 'id' and a guest might not, or has a different structure.
    const userId = users?.user_id || null; 

    if (!userId) {
        console.log("User not logged in. Opening login modal.");
        // --- ACTION FOR NON-LOGGED-IN USER ---
        // Set the pending action and open the modal
        setPendingAddToWishlist(true); 
        setIsModalOpen(true);
        // Do NOT proceed with API call
        
        return;
    }
    
    // --- ACTION FOR LOGGED-IN USER ---
    setPendingAddToWishlist(false); // Clear pending state if they were trying to log in
    
    const product_id = product.product_id;
    try {
        // This is the correct logic for updating the wishlist via API
        const res = await postData("/update-wish", { user_id: userId, product_id });
        toast.success(res.data.message);
        setLike((prev) => !prev); 
    } catch (error) {
        toast.error("Failed to update wishlist.");
        console.error("Wishlist API error:", error);
    }
};

useEffect(() => {
   if (user && pendingAddToCart) {
     handleaddtocart(); 
     setPendingAddToCart(false); 
   }
}, [user]);

// ✅ NEW: EFFECT FOR PENDING WISHLIST ACTION
useEffect(() => {
    // This runs after Google Sign-In successfully updates the 'user' state
    if (user && pendingAddToWishlist) {
        console.log("Google Login successful; completing pending wishlist action.");
        
        // Call handlewish to run the API logic with the newly available user ID
        handlewish(); 
        
        // Clear the pending state
        setPendingAddToWishlist(false);
    }
}, [user, pendingAddToWishlist]); 

  const renderStars = (rating) => (
    <div className="text-yellow-400 text-base mt-1">
      {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
    </div>
  );

 return (
    <div className={`w-full bg-white ${type === 'preview' ? 'h-80 overflow-y-auto p-2 rounded-md' : ''}`}>
      {type !== 'preview' && (
        <div className="p-4 flex items-center">
          <button onClick={() => navigate(-1)} className="text-sm bg-[#c97c5d] hover:bg-orange-300 text-black-700 px-4 py-2 rounded-lg transition mb-4">
            <IoArrowBackOutline className="text-2xl" />
          </button>
        </div>
      )}

      {carrtpopup && (
        <CartSuccessPopup
          product={prod}
          onContinueShopping={onContinueShopping}
          onGoToCart={onGoToCart}
          onBuyNow={onBuyNow}
        />
      )}

      <div className={`grid grid-cols-1 ${type === 'preview' ? 'md:grid-cols-2 gap-4' : 'md:grid-cols-5 gap-x-8'} p-4`}>
        
        {/* Image Section */}
        <div className={`md:col-span-2 flex ${type === 'preview' ? '' : 'md:sticky md:top-4 md:h-screen'}`}>
          <div className={`flex flex-col space-y-2 mr-2 ${type === 'preview' ? 'w-10' : 'w-16'}`}>
            {thumbnails.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Thumbnail ${index + 1}`}
                className={`w-full ${type === 'preview' ? 'w-10 h-10 object-cover' : 'w-full h-28'} object-cover rounded-xl shadow-lg`}
                onClick={() => setMainImage(src)}
              />
            ))}
          </div>

          <div className="flex-grow relative">
            <img
              src={mainImage}
              alt="Main"
              className="w-full h-96 md:h-full md:max-h-[85vh] object-cover rounded-xl shadow-lg"
            />
            
            {/* Out of Stock Badge */}
            {isOutOfStock && (
              <div className="absolute top-4 left-4 bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                OUT OF STOCK
              </div>
            )}
          </div>

          {!like && (
            <CiHeart 
              className="h-10 rounded-full -translate-x-10 text-red-500 cursor-pointer" 
              onClick={() => { handlewish();}}  
              size={30}
            />
          )}
          {like && (
            <FaHeart 
              className="h-10 rounded-full -translate-x-10 text-red-500 cursor-pointer" 
              onClick={() => { handlewish(); }}  
              size={30}
            />
          )}
        </div>

        {/* Info Section */}
        <div className="md:col-span-3 flex flex-col space-y-6">
          
          {/* Title, Price & Stock Status */}
          <section className="border-b pb-4">
            <h1 className="text-2xl font-medium text-gray-800">{product.product_name}</h1>
            
            {/* Stock Status Indicator */}
            <div className="mt-2 flex items-center space-x-2">
              {isOutOfStock ? (
                <span className="text-red-600 font-semibold text-sm bg-red-50 px-3 py-1 rounded-full">
                  ⚠️ Out of Stock
                </span>
              ) : (
                <span className="text-green-600 font-semibold text-sm bg-green-50 px-3 py-1 rounded-full">
                  ✓ In Stock ({totalStock} available)
                </span>
              )}
            </div>

            <div className="mt-4">
              <span className="text-red-600 text-3xl font-semibold mr-2">
                {/* ₹{childProduct ? childProduct.unit_selling_price : product.net_price_rtl} */}
                {/* ₹{childProduct ? childProduct.unit_selling_price : product.unit_selling_price} */}
 ₹{Number(childProduct ? childProduct.unit_selling_price : product.unit_selling_price).toFixed(2)}
              </span>

              <span className="text-gray-500 text-base line-through">
                ₹{product.mrp_price}
              </span>
              {/* {renderStars(rating)} */}
            </div>
            {/* <p className="text-sm text-gray-600">Inclusive of all taxes</p> */}

            <div className="flex space-x-6 mt-4">
              <div className="text-center">
                {/* <span className="text-sm font-semibold">10 days Returnable</span> */}
              </div>
              <div className="text-center">
                {/* <span className="text-sm font-semibold">Fast Delivery</span> */}
                <span className="text-sm font-semibold">Preparation Time : 24Hrs</span>

              </div>
            </div>
          </section>

          {/* Variant Options */}
          <section className="border-b pb-4">
            <div className="space-y-4">
              {variantAttributes.map((option) => {
                const values = option.Options && typeof option.Options === 'string' 
                  ? [...new Set(option.Options.split(',').map(v => v.trim()))] // Remove duplicates
                  : [];

                return (
                  <div key={option.Id}>
                    <label className="text-base font-semibold text-gray-800 block mb-2 capitalize">
                      {option.Label}: 
                      <span className="text-gray-700 font-medium ml-2">
                        {selectedVariants[option.Label]?.value || ''}
                      </span>
                    </label>
                    <div className="flex flex-wrap items-center gap-2">
                      {values.map((value, idx) => {
                        const trimmedValue = value.trim();
                        const isSelected = selectedVariants[option.Label]?.value === trimmedValue;

                        return (
                          <button
                            key={`${option.Label}-${trimmedValue}-${idx}`} 
                            onClick={() => handleVariantSelect(option, trimmedValue, setSelectedVariants)}
                            disabled={isOutOfStock}
                            className={`px-3 py-1 text-sm font-medium border rounded-md transition-all duration-200 outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-400
                              ${isOutOfStock 
                                ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed' 
                                : isSelected
                                  ? 'bg-blue-600 text-white border-blue-600'
                                  : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'
                              }`}
                          >
                            {trimmedValue}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}

              {childOptions && childOptions.filter(opt => opt.Attribute_Category !== 'Variant_Deterministic').map((option) => {
                const values = option.Options && typeof option.Options === 'string' 
                  ? option.Options.split(',') 
                  : [];

                return (
                  <div key={option.Id || option.Comp_Map_Id}>
                    <label className="text-base font-semibold text-gray-800 block mb-2 capitalize">
                      {option.Label}: 
                      <span className="text-gray-700 font-medium ml-2">
                        {selectedChildOptions[option.Label]?.value || ''}
                      </span>
                    </label>
                    <div className="flex flex-wrap items-center gap-2">
                      {values.map((value) => {
                        const trimmedValue = value.trim();
                        const isSelected = selectedChildOptions[option.Label]?.value === trimmedValue;

                        return (
                          <button
                            key={`${option.Id}-${trimmedValue}`} 
                            onClick={() => handleVariantSelect(option, trimmedValue, setSelectedChildOptions)}
                            disabled={isOutOfStock}
                            className={`px-3 py-1 text-sm font-medium border rounded-md transition-all duration-200 outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-400
                              ${isOutOfStock
                                ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                                : isSelected
                                  ? 'bg-blue-600 text-white border-blue-600'
                                  : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'
                              }`}
                          >
                            {trimmedValue}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Product Details */}
          <section>
            {/* {product.description && product.description.trim() !== '' && (
              <>
                <h3 className="text-lg font-bold mb-3 text-gray-900">Product Details</h3>
                <ul className="list-disc pl-6">
                  {product.description?.split("\n").map((line, idx) => (
                    <li key={idx}>{line}</li>
                  ))}
                </ul>
                <br />
              </>
            )} */}
{finalDescription && (
  <section>
    <h3 className="text-lg font-bold mb-3 text-gray-900">
      Product Details
    </h3>

    <ul className="list-disc pl-6">
      {finalDescription.split("\n").map((line, idx) => (
        <li key={idx}>{line}</li>
      ))}
    </ul>
  </section>
)}
            <div className="space-y-1.5">
              {commonAttributes.map((option, idx) => {
                return (
                  <div key={`${option.Label}-${idx}`} className="grid grid-cols-3 text-sm">
                    <span className="font-semibold text-gray-600 col-span-1 capitalize">{option.Label}</span>
                    <span className="text-gray-800 col-span-2 capitalize">{option.Options}</span>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Action Buttons */}
          {type !== 'preview' && type !== "Add Product" && (
            <div>
              {isOutOfStock ? (
                <div className="p-4 bg-red-50 border-2 border-red-200 rounded-lg text-center">
                  <p className="font-bold text-red-700 text-lg">⚠️ OUT OF STOCK</p>
                  <p className="text-sm text-red-600 mt-2">This product is currently unavailable.</p>
                  <p className="text-xs text-gray-600 mt-1">Please check back later or contact us for availability.</p>
                </div>
              ) : isPurchasable ? (
                
                <div className="relative inline-block">
                  
                  {existingQuantity > 0 && (
                    <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md z-10">
                      {existingQuantity}
                    </div>
                  )}
                  {/* <button
                    className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-8 py-3 rounded-lg w-full md:w-auto"
                    onClick={handleaddtocart}
                  >
                    Buy Now
                  </button> */}
                  <div className="flex flex-col gap-3">
  {/* {existingQuantity > 0 && cartItemId && ( */}
   
  {/* )} */}
<div className="flex items-center gap-4">
  <button
    onClick={decreaseQty}
    className="px-4 py-2 bg-[#c97c5d] hover:bg-orange-600 rounded-full text-xl font-bold"
  >
    −
  </button>

  <span className="text-lg font-semibold">
    {quantity}
  </span>

  <button
    onClick={increaseQty}
    className="px-4 py-2  bg-[#c97c5d] rounded-full  hover:bg-orange-600  text-xl font-bold"
  >
    +
  </button>
</div>

  <button
    className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-8 py-3 rounded-lg w-full md:w-auto"
    onClick={handleaddtocart}
  >
    Buy Now
  </button>
</div>

                </div>
              ) : (
                <div className="p-3 bg-gray-100 border border-gray-300 rounded-lg text-center">
                  {/* <p className="font-semibold text-gray-700">Please select a variant</p> */}
                  {/* <p className="text-sm text-gray-500">This product is available in different options.</p> */}
                </div>
              )}

              {/* Reviews Section */}
              <div className="mt-4">
                {isReviewsModalOpen && (
                  <Modal
                    isOpen={isReviewsModalOpen}
                    onClose={handleCloseReviewsModal}
                    title="Leave a Review"
                  >
                    <div className="max-h-[500px] overflow-y-auto">
                      <Reviews product_id={product.product_id} />
                    </div>
                  </Modal>
                )}
                
                {/* <div className="review-section">
                  <button 
                    onClick={handleOpenReviewsModal}
                    className="bg-blue-600 text-white font-bold py-2 px-4 rounded-md hover:bg-blue-700 transition"
                  >
                    Leave a Review
                  </button>
                  <ShowReviews product_id={product.product_id} />
                </div> */}
              </div>
            </div>
          )}

          {type === "Add Product" && (
            <div className="fixed bottom-4 right-4 z-50">
              <button
                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg w-full md:w-auto"
                onClick={handlesubmit}
              >
                Submit
              </button>
            </div>
          )}
        </div>

        {isModalOpen && (
          <LoginModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSignUp={setSignUp}
            setUser={setUser}
            type="product"
          />
        )}

        {isSignUp && (
          <SignupModal
            isSignUp={isSignUp}
            setSignUp={setSignUp}
            setUser={setUser}
          />
        )}
      </div>
    </div>
  );
};

export default ProductView;